import React from "react";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";

export function ApproveModal({
  isOpen,
  details,
  isDoa,
  onSetDoa,
  onApprove,
  onClose,
}) {
  return (
    <Modal
      isOpen={isOpen}
      contentLabel="Ticket Approval"
      className="confirm-modal"
    >
      <div className="card">
        <button onClick={onClose} className="confirm-modal-close">
          <MdClose />
        </button>
        <div className="card-header">Ticket Approval</div>
        <form onSubmit={onApprove}>
          <div className="card-body">
            <div>Are you sure you want to approve?</div>
            {!details?.service_center_central && (
              <div className="alert alert-warning py-2 mb-3" role="alert">
                Please choose a service center before approving.
              </div>
            )}
            <div className="mb-3">
              <p className="mb-2 text-muted" style={{ fontSize: "0.9rem" }}>
                Select the device arrival status before approving this ticket.
              </p>
              <div className="d-flex gap-2">
                <div
                  onClick={() => onSetDoa(true)}
                  style={{
                    flex: 1,
                    cursor: "pointer",
                    border: `2px solid ${isDoa === true ? "#dc3545" : "#dee2e6"}`,
                    borderRadius: "8px",
                    padding: "12px",
                    textAlign: "center",
                    background: isDoa === true ? "#fff5f5" : "#fff",
                    transition: "all 0.15s ease",
                  }}
                >
                  <div style={{ fontSize: "1.4rem" }}>⚠️</div>
                  <div
                    style={{
                      fontWeight: 600,
                      color: isDoa === true ? "#dc3545" : "#212529",
                    }}
                  >
                    DOA
                  </div>
                  <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                    Dead On Arrival
                  </div>
                </div>
                <div
                  onClick={() => onSetDoa(false)}
                  style={{
                    flex: 1,
                    cursor: "pointer",
                    border: `2px solid ${isDoa === false ? "#198754" : "#dee2e6"}`,
                    borderRadius: "8px",
                    padding: "12px",
                    textAlign: "center",
                    background: isDoa === false ? "#f0fff4" : "#fff",
                    transition: "all 0.15s ease",
                  }}
                >
                  <div style={{ fontSize: "1.4rem" }}>✅</div>
                  <div
                    style={{
                      fontWeight: 600,
                      color: isDoa === false ? "#198754" : "#212529",
                    }}
                  >
                    Non-DOA
                  </div>
                  <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                    Working condition
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer d-flex gap-2 justify-content-end">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onClose}
              data-testid="modal-approve-btn-cancel"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-outline-primary"
              data-testid="modal-approve-btn"
              disabled={!details?.service_center_central || isDoa === null}
            >
              Approve Ticket
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}
